import { render } from "./TestWebhookDeliveryView.vue?vue&type=template&id=4638a952&scoped=true"
import script from "./TestWebhookDeliveryView.vue?vue&type=script&lang=js"
export * from "./TestWebhookDeliveryView.vue?vue&type=script&lang=js"

import "./TestWebhookDeliveryView.vue?vue&type=style&index=0&id=4638a952&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4638a952"]])

export default __exports__